import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../_services/auth.service';
import { AppComponent } from 'src/app/app.component';
import { NavService } from 'src/app/_services/nav.service';

@Component({
  selector: 'etiquetas-de-clasificacion',
  templateUrl: './etiquetas.component.html',
  styleUrls: ['./etiquetas.component.css'],
})
export class EtiquetasDeClasificacionComponent implements OnInit {
  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private appComponent: AppComponent,
    private navService: NavService
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    this.appComponent.setTitle('Classification Labels');
    //this.authService.isAuthenticated();
    this.authService.pageVisit().subscribe(
      () => {},
      (error) => {
        console.log(error);
      }
    );

    this.selectedNavItem({
      parent: 'microsoftPurview.microsoftPurview',
      child: 'classificationLabels.classificationLabels',
    });
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }
}
